module.exports = __webpack_public_path__ + "static/media/pk_pot.e4816ffe.jpg";